<div class="article-detail-page">
    <div class="page-header">
        <button pButton
                icon="pi pi-arrow-left"
                label="Zurueck"
                class="p-button-text"
                (click)="onBack()">
        </button>
    </div>
    <mvs-help-article-viewer
        [slug]="slug"
        (articleNavigate)="onArticleNavigate($event)">
    </mvs-help-article-viewer>
</div>
